// noinspection JSDeprecatedSymbols

(function ($) {

    let initAlignments = function () {
        const body = document.querySelector('body');
        const scrollbar = window.innerWidth - body.clientWidth;
        body.setAttribute("style", `--scrollbar: ${scrollbar}px`);
    };


    let initNav = function () {

        let primaryNav = $('#primaryNav');
        let siteSearch = $('#siteHeader__search');
        let siteRegions = $('#siteHeader__regions');
        let siteAccount = $('#siteHeader__account');

        $('button', '#siteHeader').on('click', function () {

            let isOpen = $(this).attr('aria-expanded');
            let targetID = $(this).attr('aria-controls');
            let target;

            if (targetID === 'primaryNav') {
                target = 'primaryNav';
            } else {
                target = $('#' + targetID);
            }

            if (isOpen === 'true') {

                if (target === 'primaryNav') {
                    $([primaryNav, siteSearch, siteRegions, siteAccount]).each(function () {
                        $(this).hide()
                    });
                } else {
                    target.hide();
                }

                $(this).attr('aria-expanded', 'false').removeClass('is-active');
            } else {

                $('.siteHeader__button').not(this).attr('aria-expanded', 'false').removeClass('is-active');
                $([primaryNav, siteSearch, siteRegions, siteAccount]).each(function () {
                    $(this).hide()
                });

                if (target === 'primaryNav') {
                    $([primaryNav, siteRegions, siteAccount]).each(function () {
                        $(this).show()
                    });
                } else {
                    target.show();
                }

                $(this).attr('aria-expanded', 'true').addClass('is-active');

                if (targetID === 'siteHeader__search') {
                    $('input[type="search"], input[type="text"]', siteSearch).focus();
                }
            }
        });

        $('#searchform').on('submit', function (e) {
            let query = $(this).find('#s').val();

            if (!query.trim()) {
                e.preventDefault();

                $(this).find('input').eq(0).focus();
            }
        });

        $('details', '#primaryNav').on('toggle', function (e) {
            if (window.matchMedia('(min-width: 55rem)').matches) {
                if (e.currentTarget.open) {
                    $('details', '#primaryNav').not(this).removeAttr('open');
                }
            }
        });

        $('.siteHeader__button').on('click', function (e) {
            $('nav#primaryNav').toggleClass('is-active');
        });

        $('.siteHeader__toggleSearch').on('click', function (e) {
            $('#siteHeader__search--input').toggleClass('is-active');
        });

      $('.siteHeader__button--search').on('click', function (e) {
        $('#siteHeader__search--input').toggleClass('is-active');
        $('#primaryNav').toggleClass('is-active');
      });

    };

    let initFacets = function () {

        let isTabletOrAbove = window.matchMedia('(min-width: 47.5rem)').matches;

        if (!isTabletOrAbove) {
            $('#filters').removeAttr('open');
        }

        $(document).on('facetwp-loaded', function () {
            $('.facetwp-facet').each(function () {
                let $facet = $(this);
                let facet_name = $facet.attr('data-name');
                let facet_label = FWP.settings.labels[facet_name];

                let excludedFacets = [
                    'result_count',
                    'load_more'
                ]

                if (!excludedFacets.includes(facet_name)) {
                    if (!($facet).is(':empty')) {
                        if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
                            $facet.wrap('<div class="facet-wrap"></div>');
                            $facet.before('<div class="facet-label">' + facet_label + '</div>');
                        }
                    }
                }
            });

            let facetCounts = $('.facetwp-counts');

            if (facetCounts.length) {
                let topOfFilteredResults = (facetCounts.offset().top - window.innerHeight / 10);
                let scrollPos = window.pageYOffset;

                if (scrollPos > 1) {
                    if (topOfFilteredResults > scrollPos + window.innerHeight / 1.5 || topOfFilteredResults < scrollPos - window.innerHeight / 10) {
                        $('html, body').stop().animate({
                            scrollTop: topOfFilteredResults
                        }, 250);
                    }
                }
            }
        });
    }



    $(document).ready(function () {
        initAlignments();
        initNav();
        initFacets();
        $('html').removeClass('no-js');
    });

    $(window).on('load', function () {
        // correct anything loaded on DOM load which might need adjusting (mostly once images have loaded)
    });


})(jQuery);
